var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/plus_thin.93a40751.png","uri@2x": __webpack_public_path__ + "static/media/plus_thin.cae59642.png","uri@3x": __webpack_public_path__ + "static/media/plus_thin.20df98d0.png",
    width: 24,
    height: 24
});